/* eslint-disable react/prop-types */
import React from "react";
import { useTranslation } from "react-i18next";

const WorkProcessCard = ({ id, title, description, icon }) => {
  const { t } = useTranslation();
  return (
    <div className={id == 7 ? "m-auto col-xl-6 col-md-6" : "col-xl-4 col-md-6"}>
      <div
        className="single-work-process-inner"
        style={{ height: "240px", display: "flex" }}
      >
        <div className="thumb mb-3">
          <img src={icon} alt="img" />
        </div>
        <div className="details">
          {/* <p className="process-count">Work 01</p> */}
          <h5 className="mb-3">{t(title)}</h5>
          <ul>
            {description.map((d, i) => (
              <li key={i}>{t(d)}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WorkProcessCard;
